import { BarChart2, LineChart, PieChart, Users } from "lucide-react";

interface ChartIconProps {
  type: "revenue" | "services" | "usage" | "consumer";
}
export function ChartIcon({ type }: ChartIconProps) {
  switch (type) {
    case "revenue":
      return <LineChart className="h-5 w-5 text-muted-foreground" />;
    case "services":
      return <BarChart2 className="h-5 w-5 text-muted-foreground" />;
    case "usage":
      return <PieChart className="h-5 w-5 text-muted-foreground" />;
    case "consumer":
      return <Users className="h-5 w-5 text-muted-foreground" />;
    default:
      return <BarChart2 className="h-5 w-5 text-muted-foreground" />;
  }
}
